<template>
    <div class="lrc-format">
        <div class="format-edit" v-if="!isPreview">
            <el-input
                :disabled="disabled"
                type="textarea"
                @input="onChange"
                :rows="6"
                placeholder="填写的歌词，支持纯歌词或者lrc歌词"
                v-model="lyrics"
            ></el-input>
            <div class="tools-bar">
                <!-- <span v-if="isLrc">检测到歌词暂不支持滚动，前往</span> -->
                <el-button class="underline ai" type="text" :disabled="disabled" @click="getAILyrics">
                    <svg-icon icon-class="ai_make"></svg-icon>
                    AI制作滚动歌词
                </el-button>
                <el-button class="underline" @click="txtFormat()" :disabled="disabled" type="text">
                    <svg-icon icon-class="edit"></svg-icon>
                    调整/制作
                </el-button>
            </div>
            <div class="ai-mask" v-if="aiLoading || aiSync">
                <el-slider v-if="aiLoading" v-model="aiSlider" :show-tooltip="false"></el-slider>
                <p>AI正在识别中...</p>
                <el-button style="margin-top: 10px" type="aiStop" v-if="aiSync" @click="stopAiParse()">
                    <span class="m-icon icon-stop"></span>
                    停止生成
                </el-button>
            </div>
        </div>
        <el-dialog
            :title="preview ? '预览歌词' : '制作滚动歌词'"
            :custom-class="`lyrics-dialog ${preview ? 'lyrics-preview' : ''}`"
            :visible.sync="visible"
            append-to-body
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="800px"
        >
            <div class="lrc-content">
                <div class="operate-bar">
                    <el-button @click="onPaly" :type="preview ? 'base' : 'info'">
                        <svg-icon v-if="!playing" :icon-class="`${preview ? 'play_white' : 'play'}`"></svg-icon>
                        <svg-icon v-else :icon-class="`${preview ? 'pause_white' : 'pause'}`"></svg-icon>
                        {{ playing ? '暂停音频' : '播放音频' }}
                    </el-button>
                    <div class="right">
                        <el-button v-if="!preview" plain :disabled="preview" @click="removeTime">回退一句</el-button>
                        <el-button type="base" v-if="!preview" @click="addTime">标记「{{ currentTime }}」</el-button>
                    </div>
                </div>
                <div class="time-rogress">
                    <el-slider
                        ref="lrc-slider"
                        v-model="sliderValue"
                        show-tooltip
                        :min="0"
                        :max="sliderMax"
                        tooltip-class="lrc-tooltip"
                        :format-tooltip="showTooltip"
                        disabled
                    ></el-slider>
                    <!-- <el-slider
                        ref="lrc-slider"
                        v-model="sliderValue"
                        show-tooltip
                        :min="0"
                        :max="sliderMax"
                        tooltip-class="lrc-tooltip"
                        @input="handleSliderInput"
                        @change="changeAudioTime"
                        :format-tooltip="showTooltip"
                        @mousedown.native="userSeeking = true"
                        @mouseup.native="userSeeking = false"
                        @change.native="userSeeking = false"
                    ></el-slider> -->
                </div>
                <div ref="lrcView" class="lrc-list">
                    <div class="content">
                        <div
                            :class="['item', item.time ? 'time' : '', lyricsIndex === index ? 'current' : '', lyricsIndex >= index ? 'old' : '']"
                            v-for="(item, index) in lyricsMap"
                            :key="index"
                        >
                            <span class="time">{{ item.time ? `「${item.time}」` : '「待标记」' }}</span>
                            {{ item.text }}
                        </div>
                    </div>
                </div>
                <div class="ft-bar">
                    <el-button type="info" @click="setPreview">
                        <svg-icon v-if="preview" icon-class="out"></svg-icon>
                        {{ preview ? '退出预览' : '进入预览模式' }}
                    </el-button>
                    <div class="right">
                        <el-popconfirm
                            title="确认放弃制作的歌词吗？"
                            confirm-button-text="确认放弃"
                            cancel-button-text="继续制作"
                            v-if="!preview"
                            @confirm="onClose"
                        >
                            <el-button type="info" slot="reference">取消</el-button>
                        </el-popconfirm>
                        <el-button type="primary" style="margin-left: 12px" v-if="!preview" @click="saveLrc">保存</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {fetchAudioXcodeUrl} from '@/api/file';
import {uploadLyricByText, getAILyric} from '@/api/file';

export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        src: {
            type: String,
            require: true,
        },
        lrc: {
            type: String,
            default: '',
        },
        lyricsFileType: {
            type: Number,
            default: 2,
        },
        isPreview: {
            // 是否显示成预览模式
            type: Boolean,
            default: false,
        },
        visiblePreview: {
            // 预览显示/隐藏
            type: Boolean,
            default: false,
        },
        aiSync: {
            // AI 同步
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            visible: false, // 歌词制作弹框
            audio: new Audio(), // 播放器对象
            currentTime: '00:00.00', // 当前播放器播放时间
            lyricsIndex: 0, // 当前播放的进度下标
            sliderValue: 0, // 当前播放进度百分比
            duration: 0, // 当前歌曲播放总长度
            lyrics: '', // 歌词源文件
            playing: false, // 播放/暂停
            lyricsMap: [], // 歌词解析列表
            isLrc: false, // lrc验证是否是lrc歌词
            timeSetInterval: null, // 歌词进度定时器
            preview: false, // 预览模式
            sliderMax: 1000, // 进度长度
            userSeeking: false, // 进度是否在拖拽状态
            $lrcView: null, // 滚动视图
            aiLoading: false, // AI制作loading
            throttledUpdateProgress: null, // 节流更新滚动进度
            aiSlider: 0, // AI 进度值
            lastMarkedIndex: -1, // 最后一次标记行的索引
        };
    },
    watch: {
        src: {
            immediate: true,
            handler(value) {
                if (value) this.getPalyUrl(value);
            },
        },
        lrc: {
            immediate: true,
            handler(value) {
                if (value) this.lyrics = value;
            },
        },
        visiblePreview: {
            immediate: true,
            handler(value) {
                if (value) this.txtFormat(this.lrc);
                this.preview = this.isPreview;
                this.visible = value;
            },
        },
    },
    mounted() {
        this.setAudioEvent();
        this.throttledUpdateProgress = this.$utils.throttle(this.updateCurrentProgress, 200);
    },
    methods: {
        // 修复所有设置音频时间的操作
        safeSetCurrentTime(time) {
            if (isFinite(time) && !isNaN(time) && time >= 0) {
                this.audio.currentTime = time;
            } else {
                this.audio.currentTime = 0;
                this.sourceTime = 0;
            }
        },
        stopAiParse() {
            this.$emit('stopAiParse', false);
        },
        // 开启预览模式
        setPreview() {
            if (this.isPreview) {
                this.onClose();
                this.$emit('update:visiblePreview', false);
            }
            if (this.preview) {
                // 退出预览：保留当前时间，暂停播放
                this.preview = false;
                this.playing = false; // 停止播放
                this.audio.pause();
            } else {
                // 进入预览
                this.preview = true;
                this.safeSetCurrentTime(0);
                this.sourceTime = 0;
                this.sliderValue = 0;
                this.lyricsIndex = 0; // 重置高亮行
                this.$nextTick(() => {
                    this.playing = true;
                    this.audio.play().catch((e) => {
                        this.$message.warning('预览需手动点击播放按钮');
                    });
                });
            }
        },
        // 解析歌曲歌词
        parsingLrcTime(text) {
            let time = '';
            let sourceTime = null;
            const match = text.trim().match(/\[(\d{2}:\d{2}\.\d{2,3})\]/);
            if (!match)
                return {
                    text,
                    time,
                    sourceTime,
                };
            const lrcTime = match[1];
            text = text.replace(/\[\d{2}[\\.|\\:]\d{2}\.\d{2,3}\]/g, '');
            const [minutes, seconds] = lrcTime.split(':').map(parseFloat);
            const currentTime = minutes * 60 + seconds;
            return {text, time: lrcTime, sourceTime: currentTime};
        },
        // 解析所需前置条件
        isPrerequisites() {
            let {lyrics, src} = this;
            if (lyrics === '') {
                this.$message.error('请填写歌词进行制作');
                return false;
            }
            if (!src) {
                this.$message.error('请先上传您的音频文件');
                return false;
            }
            return true;
        },
        // 获取AI歌词
        async getAILyrics() {
            const isPrerequisites = this.isPrerequisites();
            if (!isPrerequisites) return;
            this.aiSlider = 0;
            let timeOut = null;
            try {
                let {lyrics, src} = this;
                this.aiLoading = true;
                // 上传源歌词
                const txtResponse = await uploadLyricByText({
                    lyricsDetail: lyrics,
                    lyricsFileType: 2,
                    id: '',
                });
                const txtData = txtResponse.data;
                if (!txtData.state) throw new Error(txtData.msg || '歌词上传异常！');
                const txtPath = txtData.result ? txtData.result.url : '';

                const updateInterval = 200;
                const increment = (98 * updateInterval) / 15000;
                timeOut = setInterval(() => {
                    this.aiSlider += increment;
                }, updateInterval);
                // 开始制作
                const response = await getAILyric({
                    audioUrl: src,
                    lyricUrl: txtPath,
                });
                await new Promise((resolve) => {
                    this.aiSlider = 100;
                    setTimeout(resolve, 500);
                });
                const {state, msg, result} = response.data;
                if (timeOut) clearInterval(timeOut);
                if (!state) throw new Error(msg || '制作失败，请稍后尝试！');
                this.aiLoading = false;
                this.txtFormat(result.lrc);
            } catch (error) {
                if (timeOut) clearInterval(timeOut);
                this.aiLoading = false;
                this.$message.error(error.message);
            }
        },
        // 歌词文件预处理
        txtFormat(lyrics = '') {
            lyrics = lyrics || this.lyrics;
            const isPrerequisites = this.isPrerequisites();
            if (!isPrerequisites) return;
            // lyrics = lyrics.replace(/\[\d{2}[\\.|\\:]\d{2}\.\d{2,3}\]/g, '');
            lyrics = lyrics.replace(/[\r\n]{2,}/g, '\n'); // 过滤歌词中多个连续换行符
            // this.lyrics = this.lyrics.replace(/发行方：秀动发行/g, '');
            lyrics = lyrics.trim();
            const list = lyrics.split('\n');
            // list.push('发行方：秀动发行')
            this.lyricsMap = list.map((text) => this.parsingLrcTime(text));
            this.currentTime = '00:00.00';
            this.sourceTime = 0;
            this.sliderValue = 0;
            this.lyricsIndex = 0;
            this.audio.load();
            this.visible = true;
            this.lastMarkedIndex = -1; // 重置最后标记位置
            // 查找当前最后一个标记行
            for (let i = 0; i < this.lyricsMap.length; i++) {
                if (this.lyricsMap[i].sourceTime) {
                    this.lastMarkedIndex = i;
                } else {
                    break; // 按顺序查找直到遇到未标记行
                }
            }
        },
        showTooltip() {
            return this.sliderValue ? this.formatTime((this.sliderValue * this.audio.duration) / this.sliderMax, true) : '00:00.00';
        },
        //标记时间
        addTime() {
            if (!this.playing) {
                return;
            }

            // 确保当前时间是有效值
            if (!isFinite(this.sourceTime)) {
                this.$message.warning('当前时间无效，无法标记');
                return;
            }

            const {lyricsMap, currentTime, sourceTime, lastMarkedIndex} = this;
            // 找到下一个未标记行
            const nextIndex = lastMarkedIndex + 1;
            if (nextIndex >= lyricsMap.length) {
                this.$message.success('所有歌词已标记完成');
                return;
            }

            const current = lyricsMap[nextIndex];
            // if (current.time) return;

            // 检查标记时间是否大于前一句
            if (lastMarkedIndex >= 0) {
                const prevTime = this.lyricsMap[lastMarkedIndex].sourceTime;
                if (sourceTime <= prevTime) {
                    return;
                }
            }

            // 标记当前行
            current.time = currentTime;
            current.sourceTime = sourceTime;
            this.lastMarkedIndex = nextIndex;

            this.setScroll();
        },
        setScroll() {
            const {lyricsIndex, lyricsMap} = this;
            let $lrcView = this.$refs.lrcView;
            if (!$lrcView) return;
            const validIndex = Math.min(lyricsIndex, lyricsMap.length - 1);

            if (validIndex < 3) {
                $lrcView.scrollTo({top: 0, behavior: 'smooth'});
            } else if (validIndex >= lyricsMap.length - 3) {
                $lrcView.scrollTo({
                    top: $lrcView.scrollHeight,
                    behavior: 'smooth',
                });
            } else {
                $lrcView.scrollTo({
                    top: (validIndex - 3) * 34,
                    behavior: 'smooth',
                });
            }
        },
        // 更新所有设置音频时间的地方
        // updateTime(item) {
        //     // 已标记的行不可修改时间
        //     if (item.time) return;
        //     if (this.lastMarkedIndex >= 0) {
        //         const prevTime = this.lyricsMap[this.lastMarkedIndex].sourceTime;
        //         if (item.sourceTime < prevTime) {
        //             return;
        //         }
        //     }
        //     const targetTime = item.sourceTime || 0;
        //     if (isFinite(targetTime) && targetTime >= 0) {
        //         this.safeSetCurrentTime(targetTime);
        //         this.sourceTime = targetTime;
        //         this.throttledUpdateProgress();
        //     }
        // },
        // 回退（只能从后向前逐句回退）
        removeTime() {
            this.audio.pause();
            this.playing = false;
            const {lyricsMap, lastMarkedIndex} = this;

            if (lastMarkedIndex < 0) {
                this.$message.warning('没有可回退的标记');
                return;
            }

            // 清除当前最后一句的标记
            const current = lyricsMap[lastMarkedIndex];
            current.time = null;
            current.sourceTime = null;

            // 向前查找最近的有标记的歌词行
            let newLastMarkedIndex = lastMarkedIndex - 1;
            while (newLastMarkedIndex >= 0) {
                if (lyricsMap[newLastMarkedIndex].sourceTime != null) {
                    break;
                }
                newLastMarkedIndex--;
            }

            this.lastMarkedIndex = newLastMarkedIndex;

            // 设置音频时间到新的最后标记行的时间（如果有）或者0
            let newTime = 0;
            if (this.lastMarkedIndex >= 0) {
                newTime = lyricsMap[this.lastMarkedIndex].sourceTime;
            } else {
                this.$message.success('已回退到起始位置');
            }

            // 修复：确保音频已加载
            if (this.audio.readyState < 2) {
                this.audio.load();
            }

            this.safeSetCurrentTime(newTime);
            this.sourceTime = newTime;
            this.sliderValue = (newTime / this.duration) * this.sliderMax;

            // 更新高亮行为最后标记行的下一行（如果有）
            if (this.lastMarkedIndex < lyricsMap.length - 1) {
                this.lyricsIndex = this.lastMarkedIndex + 1;
            } else {
                this.lyricsIndex = Math.min(this.lastMarkedIndex + 1, lyricsMap.length - 1);
            }

            this.setScroll();

            // 修复：重新绑定音频事件
            this.setAudioEvent();
        },
        loadAudio(url) {
            // 先完全释放旧音频资源
            if (this.audio) {
                this.audio.pause();
                this.audio.src = '';
                this.audio.removeAttribute('src');
                // 移除所有事件监听
                this.audio.onerror = null;
                this.audio.ontimeupdate = null;
                this.audio.oncanplay = null;
                this.audio.onloadedmetadata = null;
                this.audio.onended = null;
                // 释放对象引用
                this.audio.remove();
                this.audio = null;
            }
            // 创建新音频对象
            this.audio = new Audio(url);
            this.audio.preload = 'auto';

            // 设置重试上限（避免无限循环）
            let retryCount = 0;
            const maxRetries = 3;
            this.audio.onerror = () => {
                if (retryCount < maxRetries) {
                    retryCount++;
                    setTimeout(() => this.loadAudio(url), 1000);
                } else {
                    this.$message.error('音频加载失败，请检查文件');
                    this.playing = false;
                }
            };

            // 重新绑定事件
            this.setAudioEvent();
            // 重置时间状态
            this.currentTime = '00:00.00';
            this.sourceTime = 0;
            this.sliderValue = 0;

            this.audio.load();
        },
        // 获取当前歌词进度
        getCurrentLyricsProgress() {
            const {lyricsMap, sourceTime} = this;
            if (sourceTime <= 0 || !sourceTime) return;
            const currentLineIndex = lyricsMap.findIndex(
                (line, index) =>
                    line.sourceTime &&
                    line.sourceTime <= sourceTime &&
                    (index === lyricsMap.length - 1 || lyricsMap[index + 1].sourceTime > sourceTime)
            );
            // 如果是初始化未完成的打点歌词，需要对比下当前的播放进度
            if (lyricsMap[0].sourceTime && lyricsMap[0].sourceTime >= sourceTime) return 0;
            return currentLineIndex;
        },
        // 更新当前播放显示进度
        updateCurrentProgress() {
            // 预览模式：根据当前播放时间查找对应的歌词行索引
            if (this.preview) {
                const currentTime = this.sourceTime;
                const index = this.findNearestLyricIndex(currentTime);
                if (index !== -1 && index !== this.lyricsIndex) {
                    this.lyricsIndex = index;
                }
            } else {
                // 非预览模式（制作模式）：当前高亮行 = 最后标记行 + 1
                const highlightIndex = this.lastMarkedIndex + 1;
                if (highlightIndex < this.lyricsMap.length) {
                    this.lyricsIndex = highlightIndex;
                }
            }
            this.setScroll();
        },
        setAudioEvent() {
            const {audio} = this;
            // 移除旧的事件监听器
            audio.onerror = null;
            audio.ontimeupdate = null;
            audio.oncanplay = null;
            audio.onloadedmetadata = null;
            audio.onended = null;
            audio.onerror = () => {
                this.$message.error('音频文件播放错误');
            };

            // 修复时间更新逻辑
            audio.ontimeupdate = () => {
                if (!audio || !audio.readyState || audio.readyState < 2) return;
                if (this.userSeeking) return;

                const currentTime = isFinite(audio.currentTime) ? Number(audio.currentTime.toFixed(3)) : 0;
                this.sourceTime = currentTime;

                // 更新
                if (isFinite(this.duration) && this.duration > 0) {
                    this.sliderValue = parseFloat((currentTime / this.duration) * this.sliderMax);
                    this.currentTime = this.formatTime(currentTime);
                }
                // 新增：预览模式下达到最后标记行时暂停
                if (this.preview && this.lastMarkedIndex >= 0 && this.lyricsIndex === this.lastMarkedIndex) {
                    const lastTime = this.lyricsMap[this.lastMarkedIndex].sourceTime;
                    if (currentTime >= lastTime) {
                        this.audio.pause();
                        this.playing = false;
                        this.safeSetCurrentTime(lastTime); // 精确停在标记点
                    }
                }
                this.currentTime = this.formatTime(currentTime);

                if (!this.playing) return;
                this.throttledUpdateProgress();
            };

            audio.oncanplay = () => {
                if (isFinite(audio.duration) && audio.duration > 0) {
                    this.duration = audio.duration;
                }
            };
            audio.oncanplaythrough = () => {
                if (this.playing) audio.play(); // 确保缓冲足够再播放
            };

            // 添加更多事件处理
            audio.onloadedmetadata = () => {
                if (isFinite(audio.duration) && audio.duration > 0) {
                    this.duration = audio.duration;
                }
            };

            audio.onended = () => {
                this.playing = false;
            };
        },
        handleSliderInput(value) {
            if (!this.audio || this.duration <= 0) return;

            // 计算新时间
            const newTime = (value * this.audio.duration) / this.sliderMax;
            // 获取最后标记行的时间
            const lastMarkedTime = this.lastMarkedIndex >= 0 ? this.lyricsMap[this.lastMarkedIndex].sourceTime || 0 : 0;
            // 确保拖动的时间大于最后标记行的时间
            if (newTime < lastMarkedTime) {
                this.sliderValue = Math.floor((lastMarkedTime / this.audio.duration) * this.sliderMax);
                return;
            }
            // 更新当前时间显示
            this.currentTime = this.formatTime(newTime);
            this.sourceTime = newTime;

            // 更新歌词位置
            this.updateCurrentProgress();
        },
        changeAudioTime() {
            if (this.userSeeking) {
                // 计算实际时间并设置
                const newTime = (this.sliderValue * this.audio.duration) / this.sliderMax;
                // 确保新时间大于最后标记行的时间
                const lastMarkedTime = this.lastMarkedIndex >= 0 ? this.lyricsMap[this.lastMarkedIndex].sourceTime || 0 : 0;
                // 如果时间小于最后标记时间，调整到合法时间
                const adjustedTime = Math.max(newTime, lastMarkedTime);
                if (isFinite(adjustedTime) && adjustedTime >= 0) {
                    this.safeSetCurrentTime(adjustedTime);
                    this.sourceTime = adjustedTime;
                    this.currentTime = this.formatTime(adjustedTime);
                }

                // 更新歌词位置
                this.updateCurrentProgress();

                // 如果之前是播放状态，则继续播放
                if (this.playing) {
                    // 确保不会与后续的播放请求冲突
                    setTimeout(() => {
                        if (this.playing) {
                            this.audio.play().catch((error) => {
                                this.playing = false;
                                if (error.name !== 'AbortError') {
                                    console.error('播放失败:', error);
                                }
                            });
                        }
                    }, 50);
                }
            }
            this.userSeeking = false;
        },
        findNearestLyricIndex(currentTime) {
            const {lyricsMap} = this;
            let nearestIndex = -1;
            for (let i = 0; i < lyricsMap.length; i++) {
                const item = lyricsMap[i];
                if (item.sourceTime != null && item.sourceTime <= currentTime) {
                    nearestIndex = i;
                } else {
                    break; // 已排序列表可提前退出
                }
            }
            return nearestIndex;
        },
        onPause() {
            this.audio.pause();
            this.playing = false;
        },
        getLastMarkedTime() {
            return this.lastMarkedIndex >= 0 ? this.lyricsMap[this.lastMarkedIndex].sourceTime : 0;
        },
        onPaly() {
            if (this.playing) {
                this.audio.pause();
                this.playing = false;
            } else {
                // 预览模式下如果已到结尾则重置
                if (this.preview && this.sourceTime >= this.getLastMarkedTime()) {
                    this.safeSetCurrentTime(0);
                    this.sourceTime = 0;
                    this.sliderValue = 0;
                    this.lyricsIndex = 0;
                }
                // 确保使用当前设置的音频时间
                this.safeSetCurrentTime(this.sourceTime);
                this.playing = true;

                // 清除可能存在的旧错误状态
                this.audio.onerror = null;

                const playPromise = this.audio.play();
                if (playPromise !== undefined) {
                    playPromise
                        .then(() => {
                            // 成功播放后恢复错误处理
                            this.audio.onerror = () => {
                                this.$message.error('音频播放错误');
                                this.playing = false;
                            };
                        })
                        .catch((error) => {
                            console.error('播放失败:', error);
                            this.playing = false;

                            // 添加特定错误处理
                            if (error.name === 'AbortError') {
                                this.$message.warning('播放被用户中止');
                            } else {
                                this.$message.error('播放失败: ' + error.message);
                            }
                        });
                }
            }
        },
        onClose() {
            if (this.playing) this.audio.pause();
            this.playing = false;
            this.visible = false;
            if (this.timeSetInterval) {
                clearInterval(this.timeSetInterval);
                this.timeSetInterval = null;
            }
            // 重置数据
            this.audio.currentTime = 0;
            this.audio.load();
            this.currentTime = '00:00.00';
            this.duration = 0;
            this.sliderValue = 0;
            this.lyricsIndex = 0;
            this.lyricsMap = [];
            this.$nextTick(() => {
                this.$refs['lrcView'].scrollTop = 0;
            });
        },
        formatTime(currentTime) {
            if (!isFinite(currentTime)) return '00:00.00';
            const minutes = Math.floor(currentTime / 60)
                .toString()
                .padStart(2, '0');
            const seconds = (currentTime % 60).toFixed(3).padStart(6, '0');
            const millis = Math.floor((currentTime % 1) * 1000)
                .toString()
                .padStart(3, '0')
                .slice(0, 3);
            return `${minutes}:${seconds}`;
        },
        /**
         * 判断数组是否是正序排列
         * @param {Array} arr 被检查的数组
         */
        isDescendingOrder(arr) {
            for (let i = 0; i < arr.length - 1; i++) {
                if (arr[i].sourceTime == null || arr[i + 1].sourceTime == null) continue;
                if (arr[i].sourceTime > arr[i + 1].sourceTime) return false;
            }
            return true;
        },
        // 保存制作的LRC歌词
        saveLrc() {
            if (this.playing) this.audio.pause();
            if (!this.isDescendingOrder(this.lyricsMap)) return this.$message.error('相邻时间轴行的时间点不是顺序的');
            let lrc = '';
            this.lyricsMap.forEach((element) => {
                lrc += `${element.time ? `[${element.time}] ` : ''}${element.text.trim()}\n`;
            });
            this.$emit('update:lrc', lrc);
            this.$emit('update:lyricsFileType', 1);
            this.lyrics = lrc;
            this.onClose();
        },
        onChange() {
            const regex = /\[\d{2}[\\:]\d{2}\.\d{2,3}\]/;
            const isLrc = !regex.test(this.lyrics);
            const lyricsFileType = isLrc ? 2 : 1;

            this.$emit('update:lyricsFileType', lyricsFileType);
            this.isLrc = isLrc;
            this.$emit('update:lrc', this.lyrics);
        },
        async getPalyUrl(path) {
            this.loading = true;
            try {
                const res = await fetchAudioXcodeUrl(path);
                const {state, result} = res.data;
                if (!state) {
                    this.$message.error('解析音频文件异常');
                    return;
                }
                // 确保result是一个有效的URL
                if (result) {
                    this.loadAudio(result);
                } else {
                    this.$message.error('音频URL无效');
                }
            } catch (error) {
                this.$message.error('获取音频URL失败');
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss">
.ai-mask {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 1);
    text-align: center;
    border: 3px solid;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-image: linear-gradient(
            135deg,
            rgba(253, 187, 236, 1),
            rgba(252, 193, 164, 1),
            rgba(172, 188, 254, 1),
            rgba(229, 206, 255, 1),
            rgba(168, 241, 255, 1)
        )
        3 3;
    border-radius: 4px;

    .el-slider {
        position: relative;
        z-index: 9999;
        width: 60%;
        overflow: hidden;

        .el-slider__button-wrapper {
            display: none;
        }
    }

    p {
        color: $--color-primary;
        font-size: 13px;
        margin: 0px;
        line-height: 20px;
    }

    .icon-stop {
        background: url('~@/assets/img/stop.svg') no-repeat center;
        background-size: cover;
        width: 10px;
        height: 10px;
        display: inline-block;
    }
}

.lrc-format {
    .format-edit {
        position: relative;

        .el-textarea__inner {
            padding-bottom: 44px;
        }

        .tools-bar {
            text-align: right;
            color: #999;
            position: absolute;
            left: 1px;
            bottom: 1px;
            right: 1px;
            background-color: $--color-white;

            .el-button {
                margin-right: 15px;

                &.ai {
                    margin-right: 30px;
                }
            }
        }
    }
}

.lyrics-dialog {
    background: #fafafa;

    .time-rogress {
        .el-slider__runway {
            margin: 0;
            border-radius: 0px;
            background: #ece4ff;
        }

        .el-slider__runway,
        .el-slider__bar {
            height: 4px;
            border-radius: 0px;
        }

        .el-slider__bar {
            background-color: $--color-base;
        }

        .el-slider__button-wrapper {
            top: -16px;
            width: 72px;
        }

        .el-slider__button-wrapper .el-tooltip {
            width: 4px;
            height: 4px;
            border: none;
            background: $--color-base;
        }
    }

    .lrc-list {
        height: 360px;
        overflow: auto;
        background: $--color-white;
        border: 1px solid $--border-color-base;
        position: relative;

        .item {
            line-height: 34px;
            height: 34px;
            font-weight: 400;
            color: $-text-500;
            padding: 0 16px;
            position: relative;
            cursor: pointer;
            display: flex;
            padding-left: 160px;

            .time {
                width: 160px;
                position: absolute;
                left: 16px;
                text-align: left;
            }

            &.old {
                color: $-text-600;
            }

            &.current {
                color: $-text-950;
                font-weight: bold;
            }

            &:hover {
                color: $-text-600;
            }
        }
    }

    .operate-bar {
        margin-bottom: 15px;
        display: flex;

        .right {
            flex: 1;
            text-align: right;
        }
    }

    .ft-bar {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
    }

    &.lyrics-preview {
        .operate-bar {
            display: block;
            text-align: right;
        }
    }
}
</style>
